<template>
  <div>
    <list
      row-key="GroupId"
      ref="list"
      unit="团购活动"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
      @reset-query="$emit('reset-select')"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="活动名称">
          <el-input size="mini" v-model="params.GroupName" placeholder="请输入活动名称" clearable />
        </el-form-item>
        <el-form-item label="有效期">
          <el-date-picker
            size="mini"
            v-model.trim="params.StartTime"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin:0 10px;">-</span>
          <el-date-picker
            size="mini"
            v-model.trim="params.EndTime"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="状态">
          <el-select size="mini" v-model="params.Status" placeholder="请选择状态" clearable>
            <el-option label="正常" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="GroupName" label="活动名称" min-width="120px" />
        <el-table-column label="有效期" min-width="200px" show-overflow-tooltip>
          <template slot-scope="{row}">
            <span>{{row.StartTime}}</span>
            <span style="margin: 0px 5px;">~</span>
            <span>{{row.EndTime}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="GroupNumber" label="团购数量" min-width="100px" />
        <el-table-column prop="GoodsCount" label="商品数量" min-width="100px" />
        <el-table-column prop="State" label="状态" min-width="80px" align="center">
          <template slot-scope="{row}">
            <el-tag size="mini" v-if="row.State==0" type="danger">停用</el-tag>
            <el-tag size="mini" v-else type="success">正常</el-tag>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/sale/activity/group").default,
      params: {
        GroupName: "", //活动名称
        StartTime: null,
        EndTime: null,
        Status: null,
      },
    };
  },
  methods: {
    delRange(ids) {
      
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>